export enum NUpOutputOrientation {
  PORTRAIT = "Portrait",
  LANDSCAPE = "Landscape",
}

export default NUpOutputOrientation;
